import { Route } from '@angular/router';
import { MyProjectsDeactivateGuard } from './guards/my-projects-deactivate.guard';
import { ConsumerHomeComponent } from './consumer/home/home.component';
import { ConsumerSupportComponent } from './consumer/support/support.component';
import { ConsumerActivitiesComponent } from './consumer/activities/activities.component';
import { MyRequestComponent } from './consumer/my-request/my-request.component';
import { ConsumerProfileComponent } from './consumer/profile/profile.component';
import { ConsumerDelegateComponent } from './consumer/delegate/delegate.component';
import { ConsumerMyProjectsComponent } from './consumer/my-projects/my-projects.component';
import { ConsumerJoinOrganisationComponent } from './consumer/join-organisation/join-organisation.component';
import { ConsumerCreateOrganisationComponent } from './consumer/create-organisation/create-organisation.component';
import { ConsumerDataProviderEntityComponent } from './consumer/data-provider-entity/data-provider-entity.component';
import { ProviderHomeComponent } from './provider/home/home.component';
import { ProviderDashboardComponent } from './provider/dashboard/dashboard.component';
import { ProviderActivitiesComponent } from './provider/activities/activities.component';
import { ProviderProfileComponent } from './provider/profile/profile.component';
import { ProviderDelegateComponent } from './provider/delegate/delegate.component';
import { ProviderManageContributionComponent } from './provider/manage-contribution/manage-contribution.component';
import { ProviderAddDatasetComponent } from './provider/add-contributions/add-dataset/add-dataset.component';
import { ProviderAddModelComponent } from './provider/add-contributions/add-model/add-model.component';
import { ProviderMetadataComponent } from './shared/components/contribution-steps/metadata/metadata.component';
import { ProviderUploadMetadataComponent } from './shared/components/contribution-steps/upload-metadata/upload-metadata.component';
import { ProviderPreviewMetadataComponent } from './shared/components/contribution-steps/preview-metadata/preview-metadata.component';
import { ProviderAdditionalInfoComponent } from './shared/components/contribution-steps/additional-info/additionalInfo.component';
import { ProviderUploadComponent } from './shared/components/contribution-steps/upload/upload.component';
import { ProviderAccessRequestsComponent } from './provider/access-requests/access-requests.component';
import { ProviderDataProviderEntityComponent } from './provider/data-provider-entity/data-provider-entity.component';
import { ProviderSupportComponent } from './provider/support/support.component';
import { ProviderMyProjectsComponent } from './provider/my-projects/my-projects.component';
import { ProviderMyRequestComponent } from './provider/my-request/my-request.component';
import { OrgAdminHomeComponent } from './org-admin/home/home.component';
import { OrgAdminDashboardComponent } from './org-admin/dashboard/dashboard.component';
import { OrgAdminActivitiesComponent } from './org-admin/activities/activities.component';
import { OrgAdminAddContributionsComponent } from './org-admin/add-contributions/add-contributions.component';
import { OrgAdminMdmComponent } from './org-admin/mdm/mdm.component';
import { OrgAdminDelegateComponent } from './org-admin/delegate/delegate.component';
import { OrgAdminViewAllUsersComponent } from './org-admin/view-all-users/view-all-users.component';
import { UserRequestsHomeComponent } from './org-admin/user-requests/home/home.component';
import { OrgAdminManageContributionsComponent } from './org-admin/manage-contributions/manage-contributions.component';
import { AccessRequestsHomeComponent } from './org-admin/access-requests/access-requests-home.component';
import { OrgAdminOrganisationActivitiesComponent } from './org-admin/organisation-activities/organisation-activities.component';
import { OrgAdminDataProviderEntityComponent } from './org-admin/data-provider-entity/data-provider-entity.component';
import { OrgAdminProfileComponent } from './org-admin/profile/profile.component';
import { OrgAdminSupportComponent } from './org-admin/support/support.component';
import { OrgAdminMyProjectsComponent } from './org-admin/my-projects/my-projects.component';
import { OrgAdminAddDatasetComponent } from './org-admin/add-dataset/add-dataset.component';
import { OrgAdminAddModelComponent } from './org-admin/add-model/add-model.component';
import { AdminHomeComponent } from './platform-admin/home/home.component';
import { AdminDashboardComponent } from './platform-admin/dashboard/dashboard.component';
import { AdminActivitiesComponent } from './platform-admin/activities/activities.component';
import { UserActivitiesHomeComponent } from './platform-admin/user-activities/user-activities-home/user-activities-home.component';
import { AdminViewAllUsersComponent } from './platform-admin/view-all-users/view-all-users.component';
import { AdminContributionsComponent } from './platform-admin/contributions/contributions.component';
import { AdminDataUploadRequestsHomeComponent } from './platform-admin/data-upload-requests/data-upload-requests-home/data-upload-requests-home.component';
import { AdminExistingEntitiesComponent } from './platform-admin/existing-entities/existing-entities.component';
import { AdminNewRequestsComponent } from './platform-admin/new-requests/new-requests.component';
import { ChallengeHomeComponent } from './platform-admin/challenge/challenge-home/challenge-home.component';
import { DiscussionHomeComponent } from './platform-admin/discussion/discussion-home/discussion-home.component';
import { AdminProfileComponent } from './platform-admin/profile/profile.component';
import { AdminSupportComponent } from './platform-admin/support/support.component';
import { ComputeCreditHomeComponent } from './platform-admin/credit-compute/compute-credit-home/compute-credit-home.component';
import { UsecasesHomeComponent } from './shared/components/onboarding-assets/Usecases/usecases-home/usecases-home.component';
import { DatasetHome } from './catalogue/datasets/dataset-home/dataset-home';
import { DatasetDetailsHome } from './catalogue/dataset-detail/dataset-detail-home/dataset-details-home';
import { ModelHome } from './catalogue/models/model-home/model-home';
import { ModelDetailsHome } from './catalogue/model-detail/model-detail-home/model-details-home';
import { UsecaseHome } from './catalogue/usecases/usecase-home/usecase-home';
import { LeaderboardHome } from './catalogue/leaderboard/leaderboard-home';
import { SandboxComponent } from './catalogue/sandbox/sandbox.component';
import { AboutUsComponent } from './catalogue/about-us/about-us.component';
import { LandingHome } from './catalogue/landing/landing-home/landing-home';
import { authGuard } from './guards/auth.guard';
import { RoleRedirectComponent } from './shared/components/role-redirect/role-redirect.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LandingHome,
    pathMatch: 'full',
  },
  {
    path: 'datasets',
    component: DatasetHome,
    data: {
      title: 'Datasets',
      description:
        'Explore a comprehensive collection of datasets designed to unlock actionable insights, enable data-driven decision-making, and support scalable, secure innovation across domains.',
    },
  },
  {
    path: 'datasets/:id',
    component: DatasetDetailsHome,
    data: {
      title: 'Dataset details',
      description: 'View dataset description, metadata, and actions.',
    },
  },
  /** Legacy path used by asset-grid, feature-card, uploads, etc. */
  {
    path: 'dataset/:id',
    component: DatasetDetailsHome,
    data: {
      title: 'Dataset details',
      description: 'View dataset description, metadata, and actions.',
    },
  },
  {
    path: 'models',
    component: ModelHome,
    data: {
      title: 'Models',
      description:
        'Explore scalable models that convert data into intelligence, supporting innovation, optimization, and real-world problem solving.',
    },
  },
  {
    path: 'models/:id',
    component: ModelDetailsHome,
    data: {
      title: 'Model details',
      description: 'View model description, metadata, and repository link.',
    },
  },
  {
    path: 'model/:id',
    component: ModelDetailsHome,
    data: {
      title: 'Model details',
      description: 'View model description, metadata, and repository link.',
    },
  },
  {
    path: 'usecases',
    component: UsecaseHome,
    data: {
      title: 'Usecases',
      description:
        'Explore healthcare-specific analytics applications built to unlock clinical understanding, streamline research workflows, and generate privacy-preserving insights from trusted healthcare data.',
    },
  },
  {
    path: 'leadership',
    redirectTo: 'leaderboard',
    pathMatch: 'full',
  },
  {
    path: 'leaderboard',
    component: LeaderboardHome,
    data: {
      title: 'Leaderboard',
      description:
        'Explore the highest-performing organisations across the exchange based on published assets, community upvotes, and downloads.',
    },
  },
  {
    path: 'sandbox',
    component: SandboxComponent,
    data: {
      title: 'Sandbox',
      description:
        'Explore and experiment with the data platform in a secure sandbox IDE—notebooks, compute, and integration tooling.',
    },
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
    data: {
      title: 'About us',
      description:
        'Learn how IUDX Healthcare connects providers, researchers and innovators through governed data exchange, analytics and collaboration.',
    },
  },
  {
    path: 'toolset',
    loadComponent: () =>
      import('./catalogue/toolset/toolset-home').then((m) => m.ToolsetHome),
    data: {
      title: 'Toolset',
      description:
        'Browse tools and utilities for healthcare data processing, analysis, and integration on IUDX Healthcare.',
    },
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./catalogue/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent,
      ),
    data: {
      title: 'Privacy policy',
      description:
        'How IUDX Healthcare collects, uses, and protects your personal information.',
    },
  },
  {
    path: 'terms-of-service',
    loadComponent: () =>
      import('./catalogue/terms-of-service/terms-of-service.component').then(
        (m) => m.TermsOfServiceComponent,
      ),
    data: {
      title: 'Terms of service',
      description:
        'Terms and conditions for using the IUDX Healthcare platform.',
    },
  },
  {
    path: 'contact-us/thank-you',
    loadComponent: () =>
      import('./catalogue/contact-us/thank-you/thank-you.component').then(
        (m) => m.ContactThankYouComponent,
      ),
    data: {
      title: 'Thank you',
      description: 'Your message was received.',
    },
  },
  {
    path: 'contact-us',
    loadComponent: () =>
      import('./catalogue/contact-us/contact-us.component').then(
        (m) => m.ContactUsComponent,
      ),
    data: {
      title: 'Contact Us',
      description: 'Get in touch with the IUDX Healthcare team.',
    },
  },
  {
    path: 'consumer',
    component: RoleRedirectComponent,
  },
  {
    path: 'consumer/home',
    component: ConsumerHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Welcome !!',
    },
  },
  {
    path: 'consumer/activities',
    component: ConsumerActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Activities',
      description:
        'Shows the list of activities that the logged-in user has performed across the platform.',
    },
  },
  {
    path: 'consumer/support',
    component: ConsumerSupportComponent,
    canActivate: [authGuard],
    data: {
      title: 'Support Center',
      description: 'Get help and find resources to make the most of your experience',
    },
  },
  {
    path: 'consumer/requests',
    component: MyRequestComponent,
    canActivate: [authGuard],
    data: {
      title: 'Asset Request Status',
      description: 'View and Manage your asset requests',
    },
  },
  {
    path: 'consumer/profile',
    component: ConsumerProfileComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Profile',
      description: 'Manage your account settings and preferences',
    },
  },
  {
    path: 'consumer/delegate',
    component: ConsumerDelegateComponent,
    canActivate: [authGuard],
    data: {
      title: 'Delegate',
      description: 'Delegate access and manage permissions',
    },
  },
  {
    path: 'consumer/my-projects',
    component: ConsumerMyProjectsComponent,
    canActivate: [authGuard],
    canDeactivate: [MyProjectsDeactivateGuard],
    data: {
      title: 'My Projects',
      description: 'Manage and view all your projects',
    },
  },
  {
    path: 'consumer/join-organisation',
    component: ConsumerJoinOrganisationComponent,
    canActivate: [authGuard],
    data: {
      title: 'Join An Organisation',
      description:
        'Register or join an organisation on IUDX Health to begin contributing datasets, models, and usecases.',
    },
  },
  {
    path: 'consumer/create-organisation',
    component: ConsumerCreateOrganisationComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create new Organisation',
      description:
        'Register or join an organisation on IUDX Health to begin contributing datasets, models, and usecases.',
    },
  },
  {
    path: 'consumer/data-provider-entity',
    component: ConsumerDataProviderEntityComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation',
      description: 'View your organisation details',
    },
  },
  {
    path: 'provider',
    component: RoleRedirectComponent,
  },
  {
    path: 'provider/home',
    component: ProviderHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Welcome !!',
    },
  },
  {
    path: 'provider/dashboard',
    component: ProviderDashboardComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Provider dashboard overview',
    },
  },
  {
    path: 'provider/activities',
    component: ProviderActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Activities',
      description: 'View and manage your activities',
    },
  },
  {
    path: 'provider/profile',
    component: ProviderProfileComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Profile',
      description: 'Manage your account settings and preferences',
    },
  },
  {
    path: 'provider/delegate',
    component: ProviderDelegateComponent,
    canActivate: [authGuard],
    data: {
      title: 'Delegate',
      description: 'Delegate access and manage permissions',
    },
  },
  {
    path: 'provider/my-projects',
    component: ProviderMyProjectsComponent,
    canActivate: [authGuard],
    canDeactivate: [MyProjectsDeactivateGuard],
    data: {
      title: 'My Projects',
      description: 'Manage and view all your projects',
    },
  },
  {
    path: 'provider/requests',
    component: ProviderMyRequestComponent,
    canActivate: [authGuard],
    data: {
      title: 'Asset Request Status',
      description: 'View and Manage your asset requests',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset',
    component: ProviderAddDatasetComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Dataset',
      description: 'Add a new dataset to the repository',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset/metadata',
    component: ProviderMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description:
        'Manually define your metadata by filling up the form. Add titles, descriptions, field types, and schema details.',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset/upload-metadata',
    component: ProviderUploadMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Upload a JSON schema to populate metadata fields automatically.',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset/preview-metadata',
    component: ProviderPreviewMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Preview the uploaded metadata before proceeding.',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset/additionalInfo',
    component: ProviderAdditionalInfoComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Provide additional information about your dataset',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset/uploads',
    component: ProviderUploadComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Upload your dataset using one of the available methods',
    },
  },
  {
    path: 'provider/add-contributions/add-model',
    component: ProviderAddModelComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Model',
      description: 'Add a new model to the repository',
    },
  },
  {
    path: 'provider/add-contributions/add-model/metadata',
    component: ProviderMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Model',
      description:
        'Manually define your metadata by filling up the form. Add titles, descriptions, field types, and schema details.',
    },
  },
  {
    path: 'provider/add-contributions/add-model/upload-metadata',
    component: ProviderUploadMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Model',
      description: 'Upload a JSON schema to populate metadata fields automatically.',
    },
  },
  {
    path: 'provider/add-contributions/add-model/preview-metadata',
    component: ProviderPreviewMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Model',
      description: 'Preview the uploaded metadata before proceeding.',
    },
  },
  {
    path: 'provider/add-contributions/add-model/additionalInfo',
    component: ProviderAdditionalInfoComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Model',
      description: 'Provide additional information about your model',
    },
  },
  {
    path: 'provider/add-contributions/add-model/uploads',
    component: ProviderUploadComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Model',
      description: 'Upload your model using one of the available methods',
    },
  },
  {
    path: 'provider/add-contributions/dataset/metadata',
    component: ProviderMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description:
        'Manually define your metadata by filling up the form. Add titles, descriptions, field types, and schema details.',
    },
  },
  {
    path: 'provider/add-contributions/dataset/additionalInfo',
    component: ProviderAdditionalInfoComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Provide additional information about your dataset',
    },
  },
  {
    path: 'provider/add-contributions/dataset/uploads',
    component: ProviderUploadComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Upload your dataset using one of the available methods',
    },
  },
  {
    path: 'provider/manage-contributions',
    component: ProviderManageContributionComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Assets',
      description: 'View and manage your Assets',
    },
  },
  {
    path: 'provider/access-requests',
    component: ProviderAccessRequestsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Access Requests',
      description: 'View and manage access requests',
    },
  },
  {
    path: 'provider/data-provider-entity',
    component: ProviderDataProviderEntityComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation',
      description: 'View your Organisation details',
    },
  },
  {
    path: 'provider/support',
    component: ProviderSupportComponent,
    canActivate: [authGuard],
    data: {
      title: 'Support Center',
      description: 'Get help and find resources to make the most of your experience',
    },
  },
  {
    path: 'org-admin',
    component: RoleRedirectComponent,
  },
  {
    path: 'org-admin/home',
    component: OrgAdminHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Welcome !!',
    },
  },
  {
    path: 'org-admin/dashboard',
    component: OrgAdminDashboardComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Org Admin dashboard overview',
    },
  },
  {
    path: 'org-admin/activities',
    component: OrgAdminActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Activities',
      description:
        'Shows the list of activities that the logged-in user has performed across the platform.',
    },
  },
  {
    path: 'org-admin/add-contributions',
    component: OrgAdminAddContributionsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Contributions',
      description: 'Add new contributions to the platform',
    },
  },
  {
    path: 'org-admin/add-dataset',
    component: OrgAdminAddDatasetComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Dataset',
      description: 'Add a new dataset to the repository',
    },
  },
  {
    path: 'org-admin/add-dataset/metadata',
    component: ProviderMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description:
        'Manually define your metadata by filling up the form. Add titles, descriptions, field types, and schema details.',
    },
  },
  {
    path: 'org-admin/add-dataset/upload-metadata',
    component: ProviderUploadMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Upload a JSON schema to populate metadata fields automatically.',
    },
  },
  {
    path: 'org-admin/add-dataset/preview-metadata',
    component: ProviderPreviewMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Preview the uploaded metadata before proceeding.',
    },
  },
  {
    path: 'org-admin/add-dataset/additionalInfo',
    component: ProviderAdditionalInfoComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Provide additional information about your dataset',
    },
  },
  {
    path: 'org-admin/add-dataset/uploads',
    component: ProviderUploadComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Upload your dataset using one of the available methods',
    },
  },
  {
    path: 'org-admin/add-model',
    component: OrgAdminAddModelComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Model',
      description: 'Add a new model to the repository',
    },
  },
  {
    path: 'org-admin/add-model/metadata',
    component: ProviderMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Model',
      description:
        'Manually define your metadata by filling up the form. Add titles, descriptions, field types, and schema details.',
    },
  },
  {
    path: 'org-admin/add-model/upload-metadata',
    component: ProviderUploadMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Model',
      description: 'Upload a JSON schema to populate metadata fields automatically.',
    },
  },
  {
    path: 'org-admin/add-model/preview-metadata',
    component: ProviderPreviewMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Model',
      description: 'Preview the uploaded metadata before proceeding.',
    },
  },
  {
    path: 'org-admin/add-model/additionalInfo',
    component: ProviderAdditionalInfoComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Model',
      description: 'Provide additional information about your model',
    },
  },
  {
    path: 'org-admin/add-model/uploads',
    component: ProviderUploadComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Model',
      description: 'Upload your model using one of the available methods',
    },
  },
  {
    path: 'org-admin/mdm',
    component: OrgAdminMdmComponent,
    canActivate: [authGuard],
    data: {
      title: 'MDM',
      description: 'Master Data Management',
    },
  },
  {
    path: 'org-admin/delegate',
    component: OrgAdminDelegateComponent,
    canActivate: [authGuard],
    data: {
      title: 'Delegate',
      description: 'Delegate access and manage permissions',
    },
  },
  {
    path: 'org-admin/my-projects',
    component: OrgAdminMyProjectsComponent,
    canActivate: [authGuard],
    canDeactivate: [MyProjectsDeactivateGuard],
    data: {
      title: 'My Projects',
      description: 'Manage and view all your projects',
    },
  },
  {
    path: 'org-admin/view-all-users',
    component: OrgAdminViewAllUsersComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation Users',
      description: 'View and manage all users',
    },
  },
  {
    path: 'org-admin/user-requests',
    component: UserRequestsHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'User requests',
      description: 'View and manage user requests',
    },
  },
  {
    path: 'org-admin/user-requests/join-organisation-request',
    component: UserRequestsHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation Join Requests',
      description: 'View and manage join organisation requests',
    },
  },
  {
    path: 'org-admin/user-requests/role-upgradation-request',
    component: UserRequestsHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Role Upgradation',
      description: 'View and manage role upgradation requests',
    },
  },
  {
    path: 'org-admin/manage-contributions',
    component: OrgAdminManageContributionsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Assets',
      description: 'View and manage contributions',
    },
  },
  {
    path: 'org-admin/access-requests',
    component: AccessRequestsHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Access Requests',
      description: 'View and manage access requests',
    },
  },
  {
    path: 'org-admin/organisation-activities',
    component: OrgAdminOrganisationActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation Activities',
      description: 'View organisation activities',
    },
  },
  {
    path: 'org-admin/data-provider-entity',
    component: OrgAdminDataProviderEntityComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation',
      description: 'View your Organisation details',
    },
  },
  {
    path: 'org-admin/profile',
    component: OrgAdminProfileComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Profile',
      description: 'Manage your account settings and preferences',
    },
  },
  {
    path: 'org-admin/support',
    component: OrgAdminSupportComponent,
    canActivate: [authGuard],
    data: {
      title: 'Support Center',
      description: 'Get help and find resources to make the most of your experience',
    },
  },
  {
    path: 'admin',
    redirectTo: 'admin/home',
    pathMatch: 'full',
  },
  {
    path: 'admin/home',
    component: AdminHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Welcome !!',
    },
  },
  {
    path: 'admin/dashboard',
    component: AdminDashboardComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Admin dashboard overview',
    },
  },
  {
    path: 'admin/activities',
    component: AdminActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Activities',
      description: 'View all the activities that user has performed across the platform.',
    },
  },
  {
    path: 'admin/user-activities',
    component: UserActivitiesHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'User Activities',
      description:
        'View the complete history of all user activities performed accross the platform.',
    },
  },
  {
    path: 'admin/add-contributions',
    component: UsecasesHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Usecase',
      description: 'Create an Usecase to inspire your next innovation.',
    },
  },
  {
    path: 'admin/view-all-users',
    component: AdminViewAllUsersComponent,
    canActivate: [authGuard],
    data: {
      title: 'View all platform Users',
      description: 'View and manage all users',
    },
  },
  {
    path: 'admin/credit-compute',
    component: ComputeCreditHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Credit Compute',
      description: 'View and manage compute and credit requests',
    },
  },
  {
    path: 'admin/contributions',
    component: AdminContributionsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Platform Assets',
      description: 'View and manage all contributions',
    },
  },
  {
    path: 'admin/data-upload-requests',
    component: AdminDataUploadRequestsHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Data Upload requests',
      description: 'View and manage data upload requests',
    },
  },
  {
    path: 'admin/existing-entities',
    component: AdminExistingEntitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Organisations',
      description: 'View and manage manage organisations',
    },
  },
  {
    path: 'admin/new-requests',
    component: AdminNewRequestsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation Requests',
      description: 'View and manage Organisation requests',
    },
  },
  {
    path: 'admin/challenge',
    component: ChallengeHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Challenge',
      description: 'Manage challenges',
    },
    children: [
      { path: '', redirectTo: 'create', pathMatch: 'full' },
      {
        path: 'create',
        loadComponent: () =>
          import('./platform-admin/challenge/challenge-create/challenge-create.component').then(
            (m) => m.ChallengeCreateComponent
          ),
      },
      {
        path: 'scheduled',
        loadComponent: () =>
          import('./platform-admin/challenge/challenge-scheduled/challenge-scheduled.component').then(
            (m) => m.ChallengeScheduledComponent
          ),
      },
      {
        path: 'running',
        loadComponent: () =>
          import('./platform-admin/challenge/challenge-running/challenge-running.component').then(
            (m) => m.ChallengeRunningComponent
          ),
      },
      {
        path: 'evaluation',
        loadComponent: () =>
          import('./platform-admin/challenge/challenge-evaluation/challenge-evaluation.component').then(
            (m) => m.ChallengeEvaluationComponent
          ),
      },
      {
        path: 'completed',
        loadComponent: () =>
          import('./platform-admin/challenge/challenge-completed/challenge-completed.component').then(
            (m) => m.ChallengeCompletedComponent
          ),
      },
    ],
  },
  {
    path: 'admin/discussion',
    component: DiscussionHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Discussion',
      description: 'View Discussions, Review comments',
    },
  },
  {
    path: 'admin/profile',
    component: AdminProfileComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Profile',
      description: 'Manage your account settings and preferences',
    },
  },
  {
    path: 'admin/support',
    component: AdminSupportComponent,
    canActivate: [authGuard],
    data: {
      title: 'Support Center',
      description: 'Get help and find resources to make the most of your experience',
    },
  },
];
